export enum WebcontentTabEnum {
  REVIEW = "REVIEW",
  ADDED = "ADDED",
  REMOVED = "REMOVED",
  AFFILIATION = "AFFILIATION",
}

export const WEBCONTENT_TABS = {
  review: {
    identifier: WebcontentTabEnum.REVIEW,
    label: "Review",
  },
  added: {
    identifier: WebcontentTabEnum.ADDED,
    label: "Added",
  },
  removed: {
    identifier: WebcontentTabEnum.REMOVED,
    label: "Removed",
  },
  affiliation: {
    identifier: WebcontentTabEnum.AFFILIATION,
    label: "Affiliation",
    className: "font-light text-blue-700 min-w-20",
    selectedClassName: "font-bold text-blue-700",
    selectedUnderlineClassName: "bg-blue-700 w-full",
  },
};
